import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { initializeApp } from 'firebase/app';
import { AppCheck, initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { updateTheme } from './globals';
import { getStorage } from 'firebase/storage';
import { RouterOutlet } from '@angular/router';

export const app = initializeApp(environment.firebase);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'europe-west1');
export const storage = getStorage(app);

export function initAppCheckInstance(): AppCheck | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }
  try {
    if (!environment.production && window.localStorage?.getItem('appCheckDebug') === 'true') {
      (self as unknown as Record<string, unknown>).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
    }
    return initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(environment.recaptchaPublicKey),
      isTokenAutoRefreshEnabled: true,
    });
  } catch {
    return undefined;
  }
}

export const appCheck = initAppCheckInstance();

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  public pageTitle: string;

  constructor(private titleService: Title) {
    this.titleService.setTitle(environment.name.name);
    updateTheme({
      primary: environment.themeColors.primary,
      secondary: environment.themeColors.secondary,
    });
  }
  ngOnInit(): void {}
}
